import * as React from "react";
import { useState, useEffect, useRef } from "react";
import vectorIcon from "../../../../../assets/images/icons/vector.png";
import ProjectService  from "src/app/project/ProjectService";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import { getProject } from "src/services/corporateService";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import authService from 'src/app/polar-SAAS-Components/auth-service';
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";

interface Cooperate {
  id: string;
  name: string;
  totalSmsSent: number;
  totalSmsLimit: number;
  totalRemainingCount: number;
  totalRemainingWhatsappCount:number;
  totalWhatsappSent:number;
  purchaseHistory?: Array<{
    date: string;
    valuation: number;
    smsCount: number;
    paid: boolean;
    remarks: string;
  }>;
  modifiedDate: string;
}

interface KitSmsDetails {
  kitId: string;
  totalSmsSent: number;
  remainingCount: number;
  lastUpdated?: {
    year: number;
    monthOfYear: number;
    dayOfMonth: number;
  };
}

interface Project {
  id: string;
  name: string;
  totalAlertSent:number;
  totalSmsLimit?: number;
  totalRemainingCount?: number;
  purchaseHistory?: Array<{
    date: string;
    smsCount: number;
    valuation: number;
    remarks: string;
  }>;
  corporate:string;
}

interface KitUsageData {
  deviceId: string;
  alertRecipients: string;
  alertSent: number;
  nextBilling: string;
}

interface PurchaseHistoryData {
  corporate: string;
  totalSms: number;
  sent: number;
  remaining: number;
  totalAddOns: number;
  lastAddOnDate: string;
  costOfAddOn: string;
  billedDate: string;
}

const Billing = () => {
  const [selectedCorporate, setSelectedCorporate] = useState<Cooperate | null>(null);
  const [selectedProject, setSelectedProject] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [activeTab, setActiveTab] = useState('alert-sms');
  const [activeContentTab, setActiveContentTab] = useState<'project' | 'kit' | 'history'>('project');
  
  // Filter states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isDateFilterApplied,setIsDateFilterApplied]=useState(false);
  const [selectedCorporateFilter, setSelectedCorporateFilter] = useState('');
  const [projectSearchTerm, setProjectSearchTerm] = useState('');

  // Data states
  const [corporates, setCorporates] = useState<Cooperate[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [projectsFiltered,setProjectsFiltered]=useState<Project[]>([]);
  const [kitSmsDetails, setKitSmsDetails] = useState<KitSmsDetails[]>([]);
  const [kitAlertDetails, setKitAlertDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState('');
  const filterAreaRef = useRef<HTMLDivElement | null>(null);

  const [openToaster,setopenToaster]=useState(false);
  const [msg,setMsg]=useState("");
  const [success,setSuccess]=useState(true);

  // Stats
  const [totalAlertSent, setTotalAlertSent] = useState(0);
  const [totalRemaining, setTotalRemaining] = useState(0);
  const [totalAddons, setTotalAddons] = useState(0);
  const [highestAlertKit, setHighestAlertKit] = useState<{kitId: string, totalAlertSent: number} | null>(null);

  // SMS Purchase Form
  const [showSmsPopup, setShowSmsPopup] = useState(false);
  const [smsCount, setSmsCount] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState('unpaid');
  const [paymentDate, setPaymentDate] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [remarks, setRemarks] = useState('');
  const [pricePerSms, setPricePerSms] = useState(0.5);
  const [totalValuation, setTotalValuation] = useState(0);
  const [smsPopupError,setSmsPopupError]=useState({
    corporate:"",

  })

  const isMobile = useIsMobile(768);



const downloadPdf = async () => {
  try {
    const tableElement = document.querySelector('.table-container') as HTMLElement;
    
    if (!tableElement) {
      console.error('Table element not found');
      return;
    }

      const canvas = await html2canvas(tableElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      scrollY: -window.scrollY,
      onclone: (clonedDoc) => {
        const headers = clonedDoc.querySelectorAll('th');
        headers.forEach(header => {
          header.style.backgroundColor = '#2A7CED';
          header.style.color = '#ffffff';
        });
      }
    });

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgData = canvas.toDataURL('image/png');
    
    const pdfWidth = pdf.internal.pageSize.getWidth() - 20;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
    pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth, pdfHeight);
    
    let filename = 'SMS_Usage_Report';
    if (activeContentTab === 'project') {
      filename = 'SMS_Usage_by_Project';
    } else if (activeContentTab === 'kit') {
      filename = 'SMS_Usage_by_Kit';
    } else if (activeContentTab === 'history') {
      filename = 'Add-On_Purchase_History';
    }
    
    pdf.save(`${filename}_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
     setMsg('Failed to generate PDF. Please try again.');
     setSuccess(false)
      setopenToaster(true);
      setTimeout(function() {
        setopenToaster(false);
      }, 5000);
  
  }
};

  useEffect(() => {
    loadCorporates();
    
  }, [activeTab,selectedCorporate]);

  useEffect(() => {
    if (selectedCorporate) {
      loadProjectsForCorporate(selectedCorporate.id);
      if(activeTab=="alert-sms"){
      loadKitSmsDetails(selectedCorporate.id);}
      else if(activeTab=="alert-whatsapp"){
        loadKitAlertDetails(selectedCorporate.id,"WHATSAPP");
      }
    }
  }, [selectedCorporate,activeTab]);

  useEffect(() => {
    setTotalValuation(smsCount * pricePerSms);
  }, [smsCount, pricePerSms]);

  useEffect(() => {
    if (!showFilter) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (filterAreaRef.current && !filterAreaRef.current.contains(event.target as Node)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter]);

  const loadCorporates = async () => {
    setLoading(true);
    if(selectedCorporate==null){
    try {
      const response = await ProjectService.getCorporates();
      const data = response.content || response.data || [];
      setCorporates(data);
      if(activeTab=="alert-sms"){
      // Update stats based on all corporates
      const totalSent = data.reduce((sum: number, corp: Cooperate) => sum + (corp.totalSmsSent || 0), 0);
      const totalRemain = data.reduce((sum: number, corp: Cooperate) => sum + (corp.totalRemainingCount || 0), 0);
      const totalAddon = data.reduce((sum: number, corp: Cooperate) => {
      const length = corp.purchaseHistory && corp.purchaseHistory.length ? corp.purchaseHistory.length : 0;
      return sum + length;
    }, 0);
    console.log("alert sms counted", totalSent,totalRemain)

      
      setTotalAlertSent(totalSent);
      setTotalRemaining(totalRemain);
      setTotalAddons(totalAddon);
    }
      else if(activeTab=="alert-whatsapp"){
      // Update stats based on all corporates
      const totalSent = data.reduce((sum: number, corp: Cooperate) => sum + (corp.totalWhatsappSent || 0), 0);
      const totalRemain = data.reduce((sum: number, corp: Cooperate) => sum + (corp.totalRemainingWhatsappCount || 0), 0);
      setTotalAlertSent(totalSent);
      setTotalRemaining(totalRemain);
    console.log("alert whatsapp counted", totalSent,totalRemain)

      // setTotalAddons(totalAddon);
    }
      
      setLastUpdated(new Date().toLocaleString());
    } catch (error) {
      setMsg("Error loading corporates:!");
      setSuccess(false);
      setopenToaster(true);
      setTimeout(function() {
      setopenToaster(false);
    }, 5000);
      console.error("Error loading corporates:", error);
    } finally {
      setLoading(false);
    } }
    else{
      console.log("load selected corporate stats",selectedCorporate);
if(activeTab=="alert-sms"){
      // Update stats based on all corporates
      const totalSent = selectedCorporate.totalSmsSent ;
      const totalRemain = selectedCorporate.totalRemainingCount  ;
      const totalAddon = selectedCorporate.purchaseHistory && selectedCorporate.purchaseHistory.length ? selectedCorporate.purchaseHistory.length : 0;
    console.log("alert sms counted", totalSent,totalRemain)
      setTotalAlertSent(totalSent);
      setTotalRemaining(totalRemain);
      setTotalAddons(totalAddon);
    }
      else if(activeTab=="alert-whatsapp"){
      const totalSent = selectedCorporate.totalWhatsappSent ;
      const totalRemain = selectedCorporate.totalRemainingWhatsappCount  ;
      setTotalAlertSent(totalSent);
      setTotalRemaining(totalRemain);
    }

    }
  };


  const loadProjectsForCorporate = async (corporateId: string) => {
    setLoading(true);
    try {
      const response = await ProjectService.getProjectsForUser(corporateId);
      const projectsData = response.data.content || [];
      setProjects(projectsData);
      const projectsMapped = projectsData.map(project => ({
          ...project,
          corporate: selectedCorporate.name,
          totalAlertSent:activeTab=="alert-sms"?project.totalSmsSent:project.totalWhatsappSent
        }));
      setProjectsFiltered(projectsMapped);
      
      // Set the first project as selected by default
      if (projectsData.length > 0) {
        setSelectedProject(null);
      }
    } catch (error) {
      setMsg("Error loading projects!");
      setSuccess(false);
      setopenToaster(true);
      setTimeout(function() {
      setopenToaster(false);
    }, 5000);
      console.error("Error loading projects:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadKitSmsDetails = async (corporateId: string) => {
    try {
      const response = await ProjectService.getKitSmsDetailsByCorporate(corporateId);
      const kits = response.content || [];
      setKitSmsDetails(kits);
      
      // Find kit with highest SMS count
      if (kits.length > 0) {
        const maxSmsSent = Math.max(...kits.map(k => k.totalSmsSent || 0));
        const highestKit = kits.find(k => k.totalSmsSent === maxSmsSent);
        if (highestKit && maxSmsSent>0) {
          setHighestAlertKit({
            kitId: highestKit.kitId,
            totalAlertSent: highestKit.totalSmsSent
          });
        }
        else{
        setHighestAlertKit(null);

      }
      }
    } catch (error) {
        setMsg("Error loading kit SMS details");
        setSuccess(false);
        setopenToaster(true);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);
      console.error("Error loading kit SMS details:", error);
    }
  };
    const loadKitAlertDetails = async (corporateId: string,mode:string) => {
    try {
      const response = await ProjectService.getKitAlertDetailsByCorporateandMode(corporateId,mode);
      const kits = response.content || [];
      setKitAlertDetails(kits);

      // Find kit with highest alert count
      console.log("get hoghest alert for whatsapp",kits);
      if (kits.length > 0) {
        const maxAlertSent = Math.max(...kits.map(k => k.totalAlertSent || 0));
        const highestKit = kits.find(k => k.totalAlertSent === maxAlertSent);
        if (highestKit && maxAlertSent>0) {
          setHighestAlertKit({
            kitId: highestKit.kitId,
            totalAlertSent: highestKit.totalAlertSent
          });
        }
        else{
          setHighestAlertKit(null);
        }
      }
    } catch (error) {
        setMsg("Error loading kit Alert details");
        setSuccess(false);
        setopenToaster(true);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);
      console.error("Error loading kit Alert details:", error);
    }
  };

  const handleCorporateSelect = (corp: Cooperate) => {
    setSelectedCorporate(corp);
    setSelectedCorporateFilter(corp.name);
  };
  
  const handleSwitchTab=(tab)=>{
    setActiveContentTab('project');
    setActiveTab(tab)
  }
  const handleDateFilterApply = async() => {
    if (startDate && endDate && new Date(startDate) <= new Date(endDate)) {
      if (selectedCorporate) {
        try {
          setLoading(true);
          const response = await ProjectService.getKitAlertDetailsByCorporateandModeandDate(selectedCorporate.id, activeTab === "alert-sms" ? "SMS" : "WHATSAPP", startDate, endDate);
          const projectsData = response.content || [];
          console.log("Applying date filter for selected corporate:", startDate, endDate, projectsData  );
          projectsData.map(project => ({
            ...project,
            corporate: selectedCorporate.name,
            alertSent:project.totalAlertSent
          })).reduce((acc, curr) => acc.concat(curr), []);
          setProjectsFiltered(projectsData);
          const totalSent = projectsData.reduce((sum: number, proj: any) => sum + ( proj.totalAlertSent || 0), 0);
          setTotalAlertSent(totalSent);
          setTotalRemaining(null);
          setIsDateFilterApplied(true);
          setShowFilter(false);
          setLoading(false);
        }
        catch (error) {
          setStartDate('');
          setEndDate('');
          setMsg("Error applying Date filter");
          setSuccess(false);
          setopenToaster(true);
          setLoading(false);
          setTimeout(function () {
            setopenToaster(false);
          }, 5000);
        }
      }
    else{
      try{
        setLoading(true);
    const projectsForCorporates: any[] =
    (await Promise.all(
      corporates.map(async (corp): Promise<any[]> => {
        const response = await ProjectService.getKitAlertDetailsByCorporateandModeandDate(corp.id, activeTab === "alert-sms" ? "SMS" : "WHATSAPP", startDate, endDate);
        const projectsData = response.content || [];
        return projectsData.map(project => ({
          ...project,
          corporate: corp.name,
          totalAlertSent:project.totalAlertSent
        }));
      })
    )).reduce((acc, curr) => acc.concat(curr), []);
    setSelectedCorporateFilter("All Corporates");
    setProjects(projectsForCorporates);
    setProjectsFiltered(projectsForCorporates);
    setTotalRemaining(null);
    setIsDateFilterApplied(true);
    setLoading(false);
    console.log("Applying date filter:", startDate, endDate,projectsForCorporates);
    } catch (error) {
      setMsg("Error applying Date filter");
      setSuccess(false);
      setopenToaster(true);
      setLoading(false);
      setTimeout(function () {
        setopenToaster(false);
      }, 5000);
      
    }}
    }
  }
  const handleSelectAllCorporate = async () => {
    setLoading(true);
    setSelectedProject(null);
    setSelectedCorporateFilter("All Corporates");
    try{
    const projectsForCorporates: Project[] =
    (await Promise.all(
      corporates.map(async (corp): Promise<Project[]> => {
        const response = await getProject(corp.id);
        const projects = response.data.content || [];

        return projects.map(project => ({
          ...project,
          corporate: corp.name,
          totalAlertSent:activeTab=="alert-sms"?project.totalSmsSent:project.totalWhatsappSent
        }));
      })
    )).reduce((acc, curr) => acc.concat(curr), []);

    setProjects(projectsForCorporates);
    setProjectsFiltered(projectsForCorporates);
    if(activeTab=="alert-sms"&&!isDateFilterApplied){
    const kits = (await Promise.all(
    corporates.map(async (corp): Promise<any[]> => {
      const response = await ProjectService.getKitSmsDetailsByCorporate(corp.id);
      const kitsForCorproate = response.content || [];

      return kitsForCorproate;}))).reduce((acc, curr) => acc.concat(curr), []);
    setKitSmsDetails(kits);
    if (kits.length > 0) {
      let highestKit = null;
      let maxSmsSent = 0;

      for (const kit of kits) {
        const sms = kit.totalSmsSent ? kit.totalSmsSent : 0;

        if (sms > maxSmsSent) {
          maxSmsSent = sms;
          highestKit = kit;
        }
      }
      console.log("get highest alert for sms",kits,highestKit);
      if (highestKit && maxSmsSent>0) {
        setHighestAlertKit({
          kitId: highestKit.kitId,
          totalAlertSent: highestKit.totalSmsSent
        });
      }
      else{
        setHighestAlertKit(null)

      }
    }}
    else if(activeTab=="alert-whatsapp"&&!isDateFilterApplied){ 
         const kits = (await Promise.all(
    corporates.map(async (corp): Promise<any[]> => {
      const response = await ProjectService.getKitAlertDetailsByCorporateandMode(corp.id,"WHATSAPP");
      const kitsForCorproate = response.content || [];

      return kitsForCorproate;}))).reduce((acc, curr) => acc.concat(curr), []);
    setKitAlertDetails(kits);
    if (kits.length > 0) {
      let highestKit = null;
      let maxAlertSent = 0;

      for (const kit of kits) {
        const alert = kit.totalAlertSent ? kit.totalAlertSent : 0;

        if (alert > maxAlertSent) {
          maxAlertSent = alert;
          highestKit = kit;
        }
      }
      console.log("get hoghest alert for whatsapp",kits,highestKit);
      if (highestKit) {
        setHighestAlertKit({
          kitId: highestKit.kitId,
          totalAlertSent: highestKit.totalAlertSent
        });
      }
      else{
        setHighestAlertKit(null)

      }
    }

    }
    setLoading(false);
  }
    catch(error){
        setMsg("Error loading Alert count for corporates");
        setSuccess(false);
        setopenToaster(true);
        setTimeout(function () {
          setopenToaster(false);
        }, 5000);
      setLoading(false);
      
    }
  };

const handleProjectToggle = (projectName: string) => {
  setProjectsFiltered(prev => {
    const exists = prev.some(p => p.name === projectName);
    if (exists) {
      return prev.filter(p => p.name !== projectName);
    } else {
      const projectToAdd = projects.find(p => p.name === projectName);
      return projectToAdd ? [...prev, projectToAdd] : prev;
    }
  });
};

  const clearAllFilters = () => {
    setStartDate('');
    setEndDate('');
    setSelectedCorporateFilter('');
    setProjectSearchTerm('');
    setSelectedCorporate(null);
    setSelectedProject(null);
    setIsDateFilterApplied(false);
    handleSelectAllCorporate();
    setShowFilter(false);
    
  };

  const corporateOptions = [
    { name: 'All Corporates', count: null },
    ...corporates.map(corp => ({
      name: corp.name,
      count: (corp.purchaseHistory && corp.purchaseHistory.length) ? corp.purchaseHistory.length : 0
    }))
  ];

  const projectOptions = projects.map(p => p.name);

  const filteredProjects = projectOptions.filter(project =>
    project.toLowerCase().includes(projectSearchTerm.toLowerCase())
  );

  const formatPurchaseDate = (value: any) => {
    if (!value) return "";
    const dt = new Date(value);
    if (isNaN(dt.getTime())) {
      return value.toString();
    }
    return dt.toISOString().split("T")[0];
  };

  const projectData = projectsFiltered.map(project => ({
    corporate: project.corporate?project.corporate:selectedCorporate ? selectedCorporate.name : '',
    project: project.name,
    alertSent: project.totalAlertSent 
  }));

  const filteredData = projectData.filter(item =>
    item.corporate.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.project.toLowerCase().includes(searchTerm.toLowerCase())
  );

const handleAddSmsCredits = async () => {
  if (!selectedCorporate || !selectedCorporate.id) {
    setSmsPopupError(prev => ({
  ...prev,
  corporates: "Please select a corporate"
}));
    return;
  }

  if (!smsCount || smsCount <= 0) {

    setSmsPopupError(prev => ({
      ...prev,
      smsCredit: "Please enter a valid number of SMS credits"
    }));

    return;
  }

  const isPaid = paymentStatus === "paid";

  try {
    const purchase = await ProjectService.purchaseSmsCredits(selectedCorporate.id, {
      count: smsCount,
      isPaid: isPaid,
      remarks: remarks,
      pricePerSms: pricePerSms,
      ...(isPaid && {
        paymentDate: paymentDate,
        referenceNumber: referenceNumber
      })
    });

    setMsg("SMS credits added successfully!");
    setSuccess(true);
    setopenToaster(true);
    setTimeout(function() {
      setopenToaster(false);
    }, 5000);
    setShowSmsPopup(false);
    resetForm();
    loadCorporates();
    if (selectedCorporate) {
      loadProjectsForCorporate(selectedCorporate.id);
    }
  } catch (error) {
    console.error("Error adding SMS credits:", error);
    setSuccess(false);
    setMsg("Error adding SMS credits");
    setopenToaster(true);
    setTimeout(function() {
      setopenToaster(false);
    }, 5000);
};
}

  const resetForm = () => {
    setSmsCount(0);
    setPaymentStatus('unpaid');
    setPaymentDate('');
    setReferenceNumber('');
    setRemarks('');
  };

  const todayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  return (
    <>
      <div className="container1" style={{ marginTop: "12px" }}>
        <div className="header">
          <div className="search-filter-section">
            <div className="tab-section">
              <button 
                className={`tab-btn ${activeTab === 'alert-sms' ? 'active' : ''}`}
                onClick={() => handleSwitchTab('alert-sms')}
              >
                Alert SMS Usage
              </button>
              {/* <button 
                className={`tab-btn ${activeTab === 'billing' ? 'active' : ''}`}
                onClick={() => setActiveTab('billing')}
              >
                Billing Summary
              </button> */}
            </div>
            <div className="tab-section">
              <button 
                className={`tab-btn ${activeTab === 'alert-whatsapp' ? 'active' : ''}`}
                onClick={() => handleSwitchTab('alert-whatsapp')}
              >
                Alert Whatsapp Usage
              </button>
              {/* <button 
                className={`tab-btn ${activeTab === 'billing' ? 'active' : ''}`}
                onClick={() => setActiveTab('billing')}
              >
                Billing Summary
              </button> */}
            </div>
          </div>
          {activeTab=="alert-sms" &&authService.isSuperAdmin()?
          <button 
            className="add-btn-dashboard"
            onClick={() => setShowSmsPopup(true)}
            
          >
            + {isMobile?" ":"Add SMS Credit"}
          </button>:<></>}
        </div>

        <div className="search-filter-bar">
          <div className="search-container-react">
            <input
              type="text"
              className="search-input-react"
              placeholder="Search by kit or invoice id"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="search-icon-react">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.0767 3.0767C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.2664 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.2664 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z"
                  fill="#324054"
                />
              </svg>
            </span>
          </div>

          <div className="filter-section" ref={filterAreaRef}>
            <div className="select-group">
              <span className="select-label">Corporate:</span>
              <span className="select-label">{selectedCorporate ? selectedCorporate.name : selectedCorporateFilter?selectedCorporateFilter:'None selected'}</span>
            </div>
      
            <div className="select-group">
              <span className="select-label">Project:</span>
              <span className="select-label">{projectsFiltered&&projectsFiltered.length>0? projectsFiltered[0].name : 'All Projects'}</span>
              {projectsFiltered.length > 0 && (
                <span className="select-extra">+{projectsFiltered.length}</span>
              )}
            </div>
            
            <button 
              className="filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6663 2H1.33301L6.66634 8.30667V12.6667L9.33301 14V8.30667L14.6663 2Z"
                  stroke="#324054"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Filter
            </button>
            
            <button 
              className="clear-filter-btn"
              onClick={clearAllFilters}
            >
              Clear Filter
            </button>

            {showFilter && (
              <div className="filter-dropdown">
                <div className="filter-dropdown-content">
                  <div className="filter-header">
                    <h3>Filter</h3>
                    <button 
                      className="close-filter-btn"
                      onClick={() => setShowFilter(false)}
                    >
                      ×
                    </button>
                  </div>
                  
                  <div className="filter-section-date">
                    <h4>Date Range</h4>
                    <div className="date-range-inputs">
                      <div className="date-input-group">
                        <label>From</label>
                        <input 
                          type="date" 
                          placeholder="mm-dd-yyyy" 
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="date-input-group">
                        <label>To</label>
                        <input 
                          type="date" 
                          placeholder="mm-dd-yyyy" 
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                       <div className="date-input-group">
                        <button
                          type="button"
                          style={{
                            marginTop: '20px',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            fontWeight: 500,
                            fontSize: '14px',
                            cursor: 'pointer',
                            minWidth: '120px',
                            fontFamily: "'Poppins', sans-serif",
                            backgroundColor: '#2A7CED',
                            color: '#FFFFFF',
                            border: 'none',
                          }}
                          onClick={handleDateFilterApply}
                          disabled={!startDate || !endDate || (new Date(startDate) > new Date(endDate))}
                        >Apply</button>
                        </div>
                    </div>
                  </div>
                  
                  <div className="filter-cop-pro">
                    <div className="filter-section-corporate">
                      <h4>Corporate</h4>
                      <div className="filter-options">
                        {corporateOptions.map((corporate, index) => (
                          <div 
                            key={index}
                            className={`filter-option ${selectedCorporateFilter === corporate.name ? 'selected' : ''}`}
                            onClick={() => {
                              setSelectedCorporateFilter(corporate.name);
                              if (corporate.name !== 'All Corporates') {
                                const corp = corporates.find(c => c.name === corporate.name);
                                if (corp) handleCorporateSelect(corp);
                              } else {
                                setSelectedCorporate(null);
                                setSelectedCorporateFilter("All Corporates");
                                handleSelectAllCorporate();
                              }
                            }}
                          >
                            <div className="corporate-option-content">
                              <span className="corporate-option-text">{corporate.name}</span>
                              {corporate.count !== null && (
                                <span className="corporate-option-count">{corporate.count}</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div className="filter-section-project">
                      <h4>Project</h4>
                      <div className="project-search-input">
                        <input
                          type="text"
                          placeholder="Search project"
                          value={projectSearchTerm}
                          onChange={(e) => setProjectSearchTerm(e.target.value)}
                        />
                        <span className="search-icon-react">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.0767 3.0767C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.2664 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.2664 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z" fill="#9CA3AF"/>
                          </svg>
                        </span>
                      </div>
                      <div className="filter-options project-options">
                        {filteredProjects.map((project, index) => (
                          <label 
                            key={index}
                            className="filter-option project-option"
                            style={{ cursor: "pointer" }}
                          >
                            <input 
                              type="checkbox" 
                              checked={projectsFiltered.some(p => p.name === project)}
                              onChange={() => handleProjectToggle(project)}
                            />
                            <span onClick={() => handleProjectToggle(project)}>{project}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                  
                  <div className="filter-footer">
                    <button className="clear-all-btn" onClick={clearAllFilters}>
                      Clear all
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="stats-section">
          <div className="stat-card">
            <div className="stat-label">Total {activeTab=="alert-sms"?"SMS":"Whatsapp"}  Alert <span style={{ color: '#02C170' }}>Sent</span></div>
            <div className="stat-value">{totalAlertSent}</div>
            <div className="stat-updates">Last Updated: {lastUpdated}</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-label">Total {activeTab=="alert-sms"?"SMS":"Whatsapp"} Alerts <span style={{ color: '#DDA01E' }}>Remaining</span></div>
            <div className="stat-value">{isDateFilterApplied?<span style={{fontSize:"11px"}}>N/A</span>:totalRemaining}</div>
            <div className="stat-updates">Last Updated: {lastUpdated}</div>
          </div>

           {activeTab=="alert-sms"&&
           <div className="stat-card">
            <div className="stat-label">Total Add-Ons</div>
            <div className="stat-value">{totalAddons}</div>
            <div className="stat-updates">Last Updated: {lastUpdated}</div>
          </div>}
          
          <div className="stat-card dark">
            <div className="stat-label">Highest Alerts Entity</div>
            <div className="stat-value">{highestAlertKit ? highestAlertKit.kitId : 'N/A'}</div>
            <div className="stat-update">Sent: {highestAlertKit ? highestAlertKit.totalAlertSent : 0}</div>
          </div>
        </div>

        <div className="content-tabs">
          <button 
            className={`content-tab ${activeContentTab === 'project' ? 'active' : ''}`}
            onClick={() => setActiveContentTab('project')}
          >
            {activeTab=="alert-sms"?"SMS":"Whatsapp"} Usage by Project
          </button>
          <button 
            className={`content-tab ${activeContentTab === 'kit' ? 'active' : ''}`}
            onClick={() => setActiveContentTab('kit')}
          >
            {activeTab=="alert-sms"?"SMS":"Whatsapp"} Usage by KIT
          </button>
          {activeTab=="alert-sms"&&<button 
            className={`content-tab ${activeContentTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveContentTab('history')}
          >
            Add-On Purchase History
          </button>}
        </div>

        <div className="table-section">
          <div className="table-header">
            <button 
              className="download-btn"
              onClick={downloadPdf}
            >
              <img 
                src={vectorIcon} 
                alt="Download icon"
                width="16"
                height="16"
                className="download-icon"
              />
              Download Report
            </button>
          </div>
          
          <div className="table-container">
            {activeContentTab === 'project' ? (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Corporate</th>
                    <th>Project</th>
                    <th>Alert Sent</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData ? (
                    filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.corporate || selectedCorporate&&selectedCorporate.name}</td>
                          <td>{item.project}</td>
                          <td>{item.alertSent}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                          No {activeTab=="alert-sms"?"SMS":"WHATSAPP"} usage for selected corporate
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        Please select a corporate to view usage
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : activeContentTab === 'kit' ? (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Device ID</th>
                    <th>Alert Sent</th>
                    <th>Alert Sent Date</th>
                  </tr>
                </thead>
                <tbody>
                  {activeTab=="alert-sms" ?( kitSmsDetails ? (
                    kitSmsDetails.length > 0 ? (
                      kitSmsDetails.map((kit, index) => {
                        const d = kit.lastUpdated;
                        const formattedDate = d
                          ? `${d.year}-${String(d.monthOfYear).padStart(2, "0")}-${String(d.dayOfMonth).padStart(2, "0")}`
                          : "N/A";
                        return (
                          <tr key={index}>
                            <td>{kit.kitId}</td>
                            <td>{kit.totalSmsSent || 0}</td>
                            <td>{formattedDate}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                          No {activeTab=="alert-sms"?"SMS":"WHATSAPP"} usage happened for this corporate
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        Please select a corporate to view usage
                      </td>
                    </tr>
                  )) :
                  (activeTab=="alert-whatsapp") ? (
                   !isDateFilterApplied&&kitAlertDetails&&kitAlertDetails.length > 0 ? (
                      kitAlertDetails.map((kit, index) => {
                        const d = kit.lastUpdated;
                        const formattedDate = d
                          ? `${d.year}-${String(d.monthOfYear).padStart(2, "0")}-${String(d.dayOfMonth).padStart(2, "0")}`
                          : "N/A";
                        return (
                          <tr key={index}>
                            <td>{kit.kitId}</td>
                            <td>{kit.totalAlertSent || 0}</td>
                            <td>{formattedDate}</td>
                          </tr>
                        );
                      })
                    ) : (
                     <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                          { isDateFilterApplied?"date filter not available for Kit Whatsapp usage. clear date filter to view current month's data":"No WHATSAPP usage happened for this corporate"}
                        </td>
                      </tr>
                    )
                  ) : (
                  
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        {!selectedCorporate ? "Please select a corporate to view usage" : "Unknown error occurred"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
                <table className="data-table">
                <thead>
                  <tr>
                    <th>Corporate</th>
                    <th>Total SMS</th>
                    <th>Sent</th>
                    <th>Remaining</th>
                    <th>Purchased SMS</th>
                    <th>Purchased Date</th>
                    <th>Purchased SMS Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {activeTab=="alert-sms"&&(
                  !selectedCorporate ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        Please select a corporate to view purchase history
                      </td>
                    </tr>
                  ) : !selectedCorporate.purchaseHistory || selectedCorporate.purchaseHistory.length === 0 ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No Purchase history for this corporate
                      </td>
                    </tr>
                  ) : (
                    selectedCorporate.purchaseHistory.map((purchase, index) => (
                      <tr key={index}>
                        <td>{selectedCorporate.name}</td>
                        <td>{selectedCorporate.totalSmsLimit || 0}</td>
                        <td>{selectedCorporate.totalSmsSent || 0}</td>
                        <td>{selectedCorporate.totalRemainingCount || 0}</td>
                        <td>{purchase.smsCount}</td>
                        <td>{formatPurchaseDate(purchase.date)}</td>
                        <td>{purchase.valuation}</td>
                      </tr>
                    ))
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <Toaster open={openToaster} isSuccess={success} msg={msg}/>
      {loading && <Loader isLoading={loading} fullScreen={true}/>}
      {/* SMS Purchase Popup */}
      {showSmsPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(50, 64, 84, 0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          fontFamily: "'Poppins', sans-serif",
        }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            padding: '32px',
            width: '703px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          }}>

            {/* Header with title and close button */}
            <div style={{
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.1)",
              padding: "20px 24px",
              color: "rgba(60, 66, 87, 1)",
              fontSize: 16,
              fontFamily: "'Poppins', sans-serif",
              height: 69,
              fontWeight: 600,
              margin: "-31px -31px 10px -31px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <h2 style={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#324054',
                fontFamily: "'Poppins', sans-serif",
                margin: 0,
              }}>
                ADD SMS CREDITS
              </h2>
              <button
                onClick={() => {
                  setShowSmsPopup(false);
                  resetForm();
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "38px",
                  color: "#324054",
                  padding: "0",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                ×
              </button>
            </div>
            
            <form style={{ display: 'flex', flexDirection: 'column', gap: '26px' }}>
              {/* Corporate Field */}
              <div>
                <label style={{
                  display: 'block',
                  textAlign: 'left',
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#324054',
                  marginBottom: '8px',
                }}>
                  Corporate <span style={{ color: '#EF4444' }}>*</span>
                </label>
                <select 
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '4px',
                    fontSize: '16px',
                    fontWeight: 500,
                    outline: 'none',
                    fontFamily: "'Poppins', sans-serif",
                    boxSizing: 'border-box',
                    color: '#324054',
                  }}
                  value={selectedCorporate ? selectedCorporate.id : ''}
                  onChange={(e) => {
                    const corp = corporates.find(c => c.id === e.target.value);
                    if(corp){
                      setSelectedCorporateFilter(corp.name);
                    }
                    setSelectedCorporate(corp || null);

                  }}
                >
                  <option value="">Select Corporate</option>
                  {corporates.map(corp => (
                    <option key={corp.id} value={corp.id}>{corp.name}</option>
                  ))}
                </select>
              </div>
              
              {/* SMS Count, Price, and Valuation Fields */}
              <div style={{ display: 'flex', gap: '16px' }}>
                {/* Number of SMS */}
                <div style={{ flex: 1 }}>
                  <label style={{
                    display: 'block',
                    textAlign: 'left',
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#324054',
                    marginBottom: '8px',
                  }}>
                    Number of SMS <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid #E5E7EB',
                      borderRadius: '4px',
                      fontSize: '16px',
                      fontWeight: 500,
                      outline: 'none',
                      fontFamily: "'Poppins', sans-serif",
                      boxSizing: 'border-box',
                      color: '#324054',
                    }}
                    type="number"
                    min="1"
                    max="10000"
                    value={smsCount}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (value >= 1 && value <= 10000) {
                        setSmsCount(value);
                      }
                    }}
                  />
                </div>
                
                {/* Price per SMS */}
                <div style={{ flex: 1 }}>
                  <label style={{
                    display: 'block',
                    textAlign: 'left',
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#324054',
                    marginBottom: '8px',
                  }}>
                    Price per SMS (Rs) <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid #E5E7EB',
                      borderRadius: '4px',
                      fontSize: '16px',
                      fontWeight: 500,
                      outline: 'none',
                      fontFamily: "'Poppins', sans-serif",
                      boxSizing: 'border-box',
                      color: '#324054',
                    }}
                    type="number"
                    step="0.01"
                    min="0.01"
                    value={pricePerSms}
                    onChange={(e) => setPricePerSms(parseFloat(e.target.value))}
                  />
                </div>
                
                {/* Total Valuation */}
                <div style={{ flex: 1 }}>
                  <label style={{
                    display: 'block',
                    textAlign: 'left',
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#324054',
                    marginBottom: '8px',
                  }}>
                    Total Valuation (Rs)
                  </label>
                  <input
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid #E5E7EB',
                      borderRadius: '4px',
                      fontSize: '16px',
                      fontWeight: 500,
                      outline: 'none',
                      fontFamily: "'Poppins', sans-serif",
                      boxSizing: 'border-box',
                      color: '#324054',
                      backgroundColor: '#f9fafb',
                    }}
                    type="text"
                    value={`${totalValuation.toFixed(2)}`}
                    readOnly
                  />
                </div>
              </div>
              
              {/* Payment Status */}
              <div>
                <label style={{
                  display: 'block',
                  textAlign: 'left',
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#324054',
                  marginBottom: '8px',
                }}>
                  Payment Status <span style={{ color: '#EF4444' }}>*</span>
                </label>
                <div style={{ display: 'flex', gap: '16px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="radio"
                      checked={paymentStatus === 'unpaid'}
                      onChange={() => setPaymentStatus('unpaid')}
                      style={{
                        width: '16px',
                        height: '16px',
                        accentColor: '#2563eb',
                      }}
                    />
                    <span>Unpaid</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="radio"
                      checked={paymentStatus === 'paid'}
                      onChange={() => setPaymentStatus('paid')}
                      style={{
                        width: '16px',
                        height: '16px',
                        accentColor: '#2563eb',
                      }}
                    />
                    <span>Paid</span>
                  </label>
                </div>
              </div>
              
              {/* Payment Date and Reference Number (conditional) */}
              {paymentStatus === 'paid' && (
                <div style={{ display: 'flex', gap: '16px' }}>
                  {/* Payment Date */}
                  <div style={{ flex: 1 }}>
                    <label style={{
                      display: 'block',
                      textAlign: 'left',
                      fontSize: '16px',
                      fontWeight: 500,
                      color: '#324054',
                      marginBottom: '8px',
                    }}>
                      Payment Date <span style={{ color: '#EF4444' }}>*</span>
                    </label>
                    <input
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        border: '1px solid #E5E7EB',
                        borderRadius: '4px',
                        fontSize: '16px',
                        fontWeight: 500,
                        outline: 'none',
                        fontFamily: "'Poppins', sans-serif",
                        boxSizing: 'border-box',
                        color: '#324054',
                      }}
                      type="date"
                      max={todayDate()}
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                    />
                  </div>
                  
                  {/* Reference Number */}
                  <div style={{ flex: 1 }}>
                    <label style={{
                      display: 'block',
                      textAlign: 'left',
                      fontSize: '16px',
                      fontWeight: 500,
                      color: '#324054',
                      marginBottom: '8px',
                    }}>
                      Reference Number <span style={{ color: '#EF4444' }}>*</span>
                    </label>
                    <input
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        border: '1px solid #E5E7EB',
                        borderRadius: '4px',
                        fontSize: '16px',
                        fontWeight: 500,
                        outline: 'none',
                        fontFamily: "'Poppins', sans-serif",
                        boxSizing: 'border-box',
                        color: '#324054',
                      }}
                      type="text"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                  </div>
                </div>
              )}
              
              {/* Remarks */}
              <div>
                <label style={{
                  display: 'block',
                  textAlign: 'left',
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#324054',
                  marginBottom: '8px',
                }}>
                  Remarks
                </label>
                <textarea
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '4px',
                    fontSize: '16px',
                    fontWeight: 500,
                    outline: 'none',
                    fontFamily: "'Poppins', sans-serif",
                    boxSizing: 'border-box',
                    color: '#324054',
                    minHeight: '80px',
                    resize: 'vertical',
                  }}
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
              
              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '12px',
                marginTop: '16px',
                paddingTop: '16px',
                position: 'sticky',
                bottom: 0,
                backgroundColor: '#FFFFFF',
                paddingBottom: '8px',
              }}>
                <button
                  type="button"
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    fontWeight: 500,
                    fontSize: '14px',
                    cursor: 'pointer',
                    minWidth: '120px',
                    fontFamily: "'Poppins', sans-serif",
                    backgroundColor: '#FFFFFF',
                    color: '#324054',
                    border: '1px solid #324054',
                  }}
                  onClick={() => {
                    setShowSmsPopup(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    fontWeight: 500,
                    fontSize: '14px',
                    cursor: 'pointer',
                    minWidth: '120px',
                    fontFamily: "'Poppins', sans-serif",
                    backgroundColor: '#2A7CED',
                    color: '#FFFFFF',
                    border: 'none',
                  }}
                  onClick={handleAddSmsCredits}
                  disabled={!selectedCorporate || smsCount <= 0 || pricePerSms <= 0 || 
                    (paymentStatus === 'paid' && (!paymentDate || !referenceNumber))}
                >
                  Add Credits
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <style>{`
        * {
          font-family: "Poppins", sans-serif;
        }

        .container1 {
          padding: 24px;
          background-color: #f8f9fa;
          min-height: 100vh;
          overflow-y: auto;
          flex-direction: column;
          height: 100vh;
          margin-top: -40px;
        }

        /* ... (keep all existing styles from your original CSS) ... */

        /* SMS Popup Styles */
        .sms-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .sms-popup {
          background-color: white;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          width: 750px;
          max-height: 97vh;
          overflow-y: auto;
          padding: 12px;
        }

        .sms-popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          border-bottom: 1px solid #e5e7eb;
        }

        /* Add this to your style section */
          @media print {
            body * {
              visibility: hidden;
            }
            .table-container, .table-container * {
              visibility: visible;
            }
            .table-container {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }

        .sms-popup-header h3 {
          margin: 0;
          font-size: 18px;
          color: #324054;
          font-weight: 600;
        }

        .close-popup-btn {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #6b7280;
        }

        .sms-popup-body {
          padding: 16px;
        }

        .form-row {
          display: flex;
          gap: 16px;
        }

        .form-row .form-group {
          flex: 1;
        }

        .form-group {
          margin-bottom: 16px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-size: 14px;
          color: #324054;
        }

        .form-group input,
        .form-group select,
        .form-group textarea {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 14px;
          outline: none;
        }

        .form-group textarea {
          min-height: 80px;
          resize: vertical;
        }

        .payment-status-options {
          display: flex;
          gap: 16px;
          margin-top: 8px;
        }

        .payment-status-option {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
        }

        .payment-status-option input[type="checkbox"] {
          width: 16px;
          height: 16px;
          accent-color: #2563eb;
        }

        .sms-popup-footer {
          display: flex;
          justify-content: flex-end;
          padding: 16px;
          border-top: 1px solid #e5e7eb;
          gap: 8px;
        }

        .cancel-btn {
          padding: 8px 16px;
          background-color: #f3f4f6;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          color: #324054;
        }

        .confirm-btn {
          padding: 8px 16px;
          background-color: #2563eb;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          color: white;
        }

        .confirm-btn:disabled {
          background-color: #2563eb;
          cursor: not-allowed;
        }
           * {
      font-family: "Poppins", sans-serif;
    }

    .container1 {
      padding: 24px;
      background-color: #f8f9fa;
      min-height: 100vh;
      overflow-y: auto; /* Added for vertical scrolling */
      flex-direction: column;
      height: 100vh;
      margin-top: -40px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
    }

    .search-filter-section {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .tab-section {
      display: flex;
      gap: 32px;
    }

    .tab-btn {
      background: none;
      border: none;
      padding: 0 0 8px 0;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #324054;
      border-bottom: 2px solid transparent;
      transition: all 0.2s;
    }

    .tab-btn.active {
      color: #324054;
      border-bottom-color: #324054;
    }

    .add-corporate-btn {
      background-color: #2A7CED;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      transition: background-color 0.2s;
    }

    .add-corporate-btn:hover {
      background-color: #1d4ed8;
    }

    .search-filter-bar {
      display: flex;
      
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      position: relative;

    }
    

    .search-container-react {
      position: relative;
      display: flex;
      align-items: center;
    }

    .search-input-react {
      width: 240px;
      padding: 8px 36px 8px 12px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      font-size: 14px;
      background-color: white;
      outline: none;
    }

    .search-input-react:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .search-filter-bar .search-container-react .search-icon-react {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 16px;
      margin: 0;
    }

    .filter-section {
      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;
    }

    .select-group {
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: #F4F4F4;
      padding: 8px;
      height: 50px;
      border-radius: 4px;
    }

    .select-label {
      font-size: 14px;
      color: #324054;
      font-weight: 500;
    }

    .select-input {
      padding: 6px 12px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      font-size: 14px;
      background-color: white;
      outline: none;
    }

    .select-input:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .select-extra {
      font-size: 14px;
      color: #9ca3af;
    }

    .filter-btn, .clear-filter-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 6px 12px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      background: white;
      cursor: pointer;
      font-size: 14px;
      color: #6b7280;
      transition: all 0.2s;
    }

    .filter-btn:hover, .clear-filter-btn:hover {
      background-color: #f3f4f6;
    }

    .clear-filter-btn {
      border: none;
      background: none;
      justify-content: center;
    }

    .stats-section {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 24px;
      margin-bottom: 32px;
    }

    .stat-card {
      background: #F4F4F4;
      padding: 18px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .stat-card.dark {
      background: #324054;
      color: white;
    }

    .stat-label {
      font-size: 16px;
      color: #324054;
      margin-bottom: 8px;
      font-weight: 500;
    }

    .stat-card.dark .stat-label {
      color: #d1d5db;
    }

    .stat-value {
      font-size: 30px;
      font-weight: bold;
      color: #111827;
      margin-bottom: 4px;
    }

    .stat-card.dark .stat-value {
      color: white;
    }

    .stat-update {
      font-size: 12px;
      color: #FFFFFF;
    }

    .stat-updates {
      font-size: 12px;
      color: #868DAA;
    }

    .content-tabs {
      display: flex;
      border-bottom: 1px solid #e5e7eb;
      margin-bottom: 24px;
    }

    .content-tab {
      background: none;
      border: none;
      padding: 0 0 12px 0;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #324054;
      border-bottom: 2px solid transparent;
      transition: all 0.2s;
      width: 100%;
    }

    .content-tab.active {
      color: #324054;
      border-bottom-color: #324054;
    }

    .table-section {
      background: white;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      overflow: auto;
    }

    .table-header {
      display: flex;
      justify-content: flex-end;
      padding: 12px;
      border-bottom: 1px solid #e5e7eb;
      position: sticky; /* Added to keep header in place */
      top: 0; /* Added to keep header at top */
      background: white; /* Added to maintain background */
      z-index: 1; /* Added to ensure header stays above table content */
    }

    .download-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px;
      border: 1px solid #324054;
      border-radius: 4px;
      background: white;
      cursor: pointer;
      font-size: 14px;
      color: #324054;
      transition: all 0.2s;
    }

    .download-btn:hover {
      background-color: #f3f4f6;
    }

    .table-container {
      overflow-x: auto;
    }

    .data-table {
      width: 100%;
      border-collapse: collapse;
    }

    .data-table th {
      background: #f9fafb;
      padding: 12px 24px;
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      color: #324054;
      letter-spacing: 0.05em;
      position: sticky; /* Added to keep table headers in place */
      top: 0; /* Added to keep headers at top */
      z-index: 1; /* Added to ensure headers stay above table content */
      background: #f9fafb; /* Added to maintain header background */
    }

    .data-table td {
      padding: 16px 24px;
      font-size: 14px;
      color: #111827;
      border-bottom: 1px solid #e5e7eb;
    }

    .data-table tr:hover {
      background-color: #f9fafb;
    }

    .filter-dropdown {
      position: absolute;
      right: 0;
      top: 100%;
      z-index: 100;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
      width: 600px;
      max-height: 500px;
      overflow-y: auto; 
      margin-top: 8px;
    }

    .filter-dropdown-content {
      padding: 16px;
    }

    .filter-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      position: sticky; /* Added to keep filter header in place */
      top: 0; /* Added to keep filter header at top */
      background: white; /* Added to maintain background */
      z-index: 1; /* Added to ensure filter header stays above content */
    }

    .filter-header h3 {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
      margin: 0;
    }

    .close-filter-btn {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #6b7280;
    }

    .filter-section-date,
    .filter-section-corporate,
    .filter-section-project {
      margin-bottom: 20px;
    }

    .filter-section-corporate {
      margin-right: 40px;
    }

    .filter-section-date h4,
    .filter-section-corporate h4,
    .filter-section-project h4 {
      font-size: 16px;
      font-weight: 500;
      color: #324054;
      margin-bottom: 12px;
    }

    .date-range-inputs {
      display: flex;
      gap: 16px;
    }

    .date-input-group {
      flex: 1;
      position: relative;
    }

    .date-input-group label {
      display: block;
      font-size: 12px;
      color: #6b7280;
      margin-bottom: 4px;
    }

    .date-input-group input {
      width: 100%;
      padding: 8px 32px 8px 12px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      font-size: 14px;
      outline: none;
    }

    .date-input-group input:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .calendar-icon {
      position: absolute;
      right: 8px;
      top: 28px;
      pointer-events: none;
    }

    .filter-cop-pro {
      display: flex;
      position: relative;
    }

    .filter-cop-pro::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: #E2E5ED;
      transform: translateX(-50%);
    }

    .filter-options {
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow-y: auto;
      max-height: 190px;
    }

    .filter-option {
      padding: 8px 12px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      background-color: #f9fafb;
      transition: all 0.2s;
    }

    .filter-option:hover {
      background-color: #f3f4f6;
    }

    .filter-option.selected {
      background-color: #dbeafe;
      color: #1d4ed8;
      border-left: 4px solid #2563eb;
    }

    .corporate-option-content {
      display: flex;
      justify-content: space-between;
      align-items: center;

    }

    .corporate-option-count {
      background-color: #e5e7eb;
      color: #6b7280;
      font-size: 12px;
      padding: 2px 6px;
      border-radius: 12px;
      font-weight: 500;
    }

    .filter-option.selected .corporate-option-count {
      background-color: #2563eb;
      color: white;
    }

    .project-search-input {
      position: relative;
      margin-bottom: 12px;
    }

    .project-search-input input {
      width: 100%;
      padding: 8px 32px 8px 12px;
      border: 1px solid #d1d5db;
      border-radius: 4px;
      font-size: 14px;
      outline: none;
    }

    .project-search-input input:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .search-icon-react {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    .project-options {
      max-height: 200px;
      overflow-y: auto;
    }

    .project-option {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      background-color: transparent;
    }

    .project-option:hover {
      background-color: #f3f4f6;
    }

    .project-option input[type="checkbox"] {
      width: 16px;
      height: 16px;
      accent-color: #2563eb;
    }

    .filter-footer {
      justify-content: flex-end;
      margin-top: 16px;
      position: sticky; /* Added to keep filter footer in place */
      bottom: 0; /* Added to keep filter footer at bottom */
      background: white; /* Added to maintain background */
      z-index: 1; /* Added to ensure filter footer stays above content */
    }

    .clear-all-btn {
      background: none;
      border: none;
      color: #2563eb;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      padding: 8px 16px;
      transition: color 0.2s;
    }

    .data-table tr:nth-child(odd) {
      background-color: #F4F4F4;
    }

    @media (max-width: 768px) {
      .search-filter-bar {
        flex-direction: column;}
      .filter-section{
        flex-direction: column;
        align-items: stretch !important;}
      .search-input-react {
        width: 100% !important ;}
      .header .header-mobile{
        flex-direction: column !important;}
      .filter-dropdown-content{
      width:100% !important;} 
      .filter-cop-pro {
        flex-direction:column;
      }
      .filter-dropdown{
      width:100% !important;
            }
      .container1{
      padding:2px !important;}
      .filter-section-corporate{
      margin-right:0px !important;}
      .corporate-option-content{
         
          }
     .corporate-option-text {
        width: 80% !important;
        overflow-x: hidden;
        text-overflow: ellipsis;
    }
      .corporate-option-count {
        width:20% !important}

    .clear-all-btn:hover {
      color: #1d4ed8;
    },
    .filter-options{
    align-items: stretch !important;},
    .filter-option{
    width:100% !important;}
    .corporate-option-content{
    width:100% !important;}
    .date-range-inputs{
    flex-direction:column !important;}

      `}</style>
    </>
  );
};

export default Billing;
